import { render, staticRenderFns } from "./FreightEstimatesModal.vue?vue&type=template&id=6bdb99cd&scoped=true&"
import script from "./FreightEstimatesModal.vue?vue&type=script&lang=js&"
export * from "./FreightEstimatesModal.vue?vue&type=script&lang=js&"
import style0 from "./FreightEstimatesModal.vue?vue&type=style&index=0&id=6bdb99cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdb99cd",
  null
  
)

export default component.exports